import combineReducers from 'redux-immutable-combine-reducers';

function requireAll(requireContext) {
  const reducers = {};
  requireContext.keys().forEach((key) => {
    const name = key.match(/^\.\/([A-z]+)\/[^/]*$/);
    const context = requireContext(key);
    if (typeof context.default === 'function') {
      reducers[name[1]] = context.default;
    } else {
      reducers[name[1]] = context.reducer;
    }
  });

  return reducers;
}

const reducers = requireAll(require.context('./', true, /^\.\/(?:[A-z]+\/)[^/]*(index|reducer)\.js$/));

export default combineReducers(reducers);



// WEBPACK FOOTER //
// ./src/store/reducers.js